var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"comment-more"},_vm._l((3),function(index){return _c('span',{key:index,staticClass:"comment-more-circle"})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }